import * as React from 'react';
import { useNotification } from '../../hooks/notification/notification';
import { Toast } from '@revenuewell/ui-notifications';
import style from './app-notifications.module.scss';

export const AppNotifications: React.FC = () => {
    const { notifications } = useNotification();
    
    return (
        <div className={style['notification-list']}>
            <link rel='stylesheet' href='https://cdnjs.cloudflare.com/ajax/libs/animate.css/3.5.2/animate.min.css' />
            { notifications.map((notification, index) => (
                <Toast {...notification} key={index} />
            ))}
        </div>
    );
};